<template>
    <div class="flex flex-col justify-end items-center bg-gray-50 allocation-preview-section-rounded-bottom px-2.5">
        <div
            class="flex flex-row justify-center relative"
            :style="{
                marginLeft: `${props.leftCompensationInRem}rem`,
                marginRight: `${props.rightCompensationInRem}rem`,
                bottom: `-${allocationHeightInRem}rem`,
            }"
        >
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { allocationHeightInRem } from '../sharedStyles';

type AllocationPreviewSectionProps = { leftCompensationInRem: number; rightCompensationInRem: number };

const props = defineProps<AllocationPreviewSectionProps>();

const heightRoundedBottom = computed(() => `${allocationHeightInRem / 2 + 0.0625}rem`);
const bottomRoundedBottom = computed(() => `-${allocationHeightInRem / 2 + 0.0625}rem`);
</script>

<style scoped>
.allocation-preview-section-rounded-bottom {
    position: relative;
}

.allocation-preview-section-rounded-bottom::after {
    position: absolute;
    height: v-bind('heightRoundedBottom');
    bottom: v-bind('bottomRoundedBottom');
    left: 0;
    right: 0;
    width: 100%;
    background: var(--color-gray-50);
    content: '';
    z-index: -20;
    border-bottom-left-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
}
</style>
